import { Injectable } from '@angular/core';
import { ApexOptions } from 'ng-apexcharts';
import { consumiChartObj } from '@reenstudio/app/core/models/charts/consumi-model';
import { oreMapCharts } from '@reenstudio/app/core/enum/chart-enum';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class ConsumiChartService {
  public chartOptions: Partial<ApexOptions>;

  getCosnumiData(chartObj: consumiChartObj, data: any): consumiChartObj {
    if (
      chartObj.startPeriod > 1 &&
      (chartObj.type === 'days' || chartObj.type === 'custom')
    ) {
      const updatedChartObj = {
        ...chartObj,
        series: [
          {
            name: 'Consumi',
            color: '#26A0FC',
            data: data.map((item: any) => item.consumption),
          },
          {
            name: 'Produzione',
            color: '#26E7A6',
            data: data.map((item: any) => item.product),
          },
        ],
        labelDate: data.map((item: any) =>
          moment(item.hour).format('DD/MM/YYYY HH:mm')
        ),

        overwriteLabelDate: data.map((item: any) => {
          const hour = moment(item.hour).format('HH:mm');
          if (hour === '12:00') {
            return moment(item.hour).format('DD/MM/YYYY');
          } else {
            return '';
          }
        }),
      };

      return updatedChartObj;

      // chartObj.series = [
      //   {
      //     name: 'Consumi',
      //     // type: 'area',
      //     color: '#26A0FC',
      //     data: data.map((item: any) => item.consumption),
      //     // data: data.map((item: any) => ({
      //     //   x: moment(item.hour).toDate().getTime(),
      //     //   y: item.consumption,
      //     // })),
      //   },
      //   {
      //     name: 'Produzione',
      //     // type: 'area',
      //     color: '#26E7A6',
      //     data: data.map((item: any) => item.product),

      //     // data: data.map((item: any) => ({
      //     //   x: moment(item.hour).toDate().getTime(),
      //     //   y: item.product,
      //     // })),
      //   },
      // ];

      // chartObj.labelDate = data.map((item: any) => {
      //   return moment(item.hour).format('DD/MM/YYYY HH:mm');
      // });

      // chartObj.overwriteLabelDate = data.map((item: any) => {
      //   const hour = moment(item.hour).format('HH:mm');
      //   if (hour === '12:00') {
      //     return moment(item.hour).format('DD/MM/YYYY');
      //   } else {
      //     return '';
      //   }
      // });
      // setTimeout(() => {
      //   return chartObj;
      // }, 1000);
      // // Mappa per associare il nome dell'ora con l'indice nell'array
      // const oreMap = oreMapCharts;
      // // Creazione dell'array risultante
      // const consumiOrariArray: any = [];
      // // Ciclo attraverso i dati della chiamata API
      // data.forEach((item: any) => {
      //   const ora = item.hour.split('T')[1].slice(0, 2);
      //   const index = oreMap[ora];
      //   if (!consumiOrariArray[index]) {
      //     // Se l'oggetto per quell'ora non esiste, crealo
      //     consumiOrariArray[index] = {
      //       name: `Consumo ore ${ora}`,
      //       group: ora,
      //       color: '#269ffb',
      //       data: [],
      //     };
      //     // Crea anche l'oggetto per la produzione
      //     consumiOrariArray[index + 24] = {
      //       name: `Produzione ore ${ora}`,
      //       group: ora,
      //       color: '#26e7a5',
      //       data: [],
      //     };
      //   }
      //   // Aggiungi i dati di consumo e produzione all'array
      //   consumiOrariArray[index].data.push(parseInt(item.consumption));
      //   consumiOrariArray[index + 24].data.push(parseInt(item.product));
      // });
      // // Rimuovi eventuali elementi null dall'array
      // const consumiOrariFinali = consumiOrariArray.filter(
      //   (item: any) => item !== null
      // );
      // const dataLength = consumiOrariFinali.size;
      // chartObj.dataLength = dataLength * 100;
      // chartObj.series = consumiOrariFinali;
      // chartObj.legend = false;
      // return chartObj;
    } else if (
      chartObj.startPeriod === 1 &&
      (chartObj.type === 'days' || chartObj.type === 'custom')
    ) {
      let prodotto: number[] = [];
      let consumato: number[] = [];
      let date: Date[] = [];
      let ore: number[] = [];

      for (let value of data) {
        prodotto.push(value.product);
        consumato.push(value.consumption);
        date.push(new Date(value.hour));
      }
      for (let ora of date) {
        ore.push(ora.getHours());
      }

      chartObj.labelDate = ore;
      chartObj.legend = true;

      chartObj.series = [
        {
          name: 'Prodotto',
          color: '#26e7a5',
          data: prodotto,
        },
        {
          name: 'Consumato',
          color: '#269ffb',
          data: consumato,
        },
      ];

      const dataLength = prodotto.length + consumato.length;
      chartObj.dataLength = dataLength * 100;

      return chartObj;
    } else if (chartObj.type === 'months') {
      const totaliGiornalieriMap = new Map<string, any>();
      for (let item of data) {
        const date = new Date(item.hour);
        const formattedDate = this.formatDate(date);

        const key = formattedDate;

        if (!totaliGiornalieriMap.has(key)) {
          // Se la chiave non esiste, crea un nuovo oggetto
          totaliGiornalieriMap.set(key, {
            group: formattedDate,
            consumoTotale: 0,
            produzioneTotale: 0,
          });
        }

        // Aggiorna i dati sommando i consumi e la produzione
        const totaliGiornalieri = totaliGiornalieriMap.get(key)!;
        totaliGiornalieri.consumoTotale += parseInt(item.consumption);
        totaliGiornalieri.produzioneTotale += parseInt(item.product);
      }

      // Crea l'array risultatoFinale con i dati totali giornalieri
      const risultatoFinaleArray: any[] = [];

      const dataLength = totaliGiornalieriMap.size;
      chartObj.dataLength = dataLength * 100;

      risultatoFinaleArray.push({
        name: 'Consumo giornaliero',
        color: '#269ffb',
        data: Array.from(
          totaliGiornalieriMap.values(),
          (item) => item.consumoTotale
        ),
      });

      risultatoFinaleArray.push({
        name: 'Produzione giornaliera',
        color: '#26e7a5',
        data: Array.from(
          totaliGiornalieriMap.values(),
          (item) => item.produzioneTotale
        ),
      });

      chartObj.legend = true;
      chartObj.series = risultatoFinaleArray;

      return chartObj;
    }

    return chartObj;
  }

  setConsumiChart(chartObj: consumiChartObj): Partial<ApexOptions> {
    if (chartObj.type === 'months') {
      chartObj = this.createLabelDates(chartObj);
      this.chartOptions = {
        series: chartObj.series,
        chart: {
          type: 'bar',
          height: 400,
          stacked: false,
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
        },
        colors: [
          '#26e7a5', // Produzione
          '#269ffb', //Consumato
        ],
        xaxis: {
          categories: chartObj.labelDate,
          tickPlacement: 'true',
        },
        yaxis: {
          labels: {
            formatter: (val) => {
              return (+val / 1000).toFixed(1) + 'kWh';
            },
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '80%',
          },
        },
        stroke: {
          width: 4,
          colors: ['transparent'],
        },
        legend: {
          show: chartObj.legend,
          horizontalAlign: 'left',
          floating: false,

          showForSingleSeries: false,
          showForNullSeries: false,
          showForZeroSeries: false,
        },
        dataLabels: {
          enabled: false,
        },
        // tooltip: {
        //   y: {
        //     formatter: function (val) {
        //       return (+val / 1000).toFixed(1) + 'kWh';
        //     },
        //   },
        // },
      };
    } else if (chartObj.startPeriod > 1 && chartObj.startPeriod < 7) {
      // chartObj = this.createLabelDates(chartObj);
      this.chartOptions = {
        series: chartObj.series,
        chart: {
          type: 'bar',
          height: 400,
          width: 5000, // new
          offsetX: 0, // new
          // stacked: false,
          // toolbar: {
          //   show: true,
          // offsetX: 400,
          // tools: {
          //   download: true,
          //   selection: true,
          //   zoom: true,
          //   zoomin: true,
          //   zoomout: true,
          //   pan: true,
          //   reset: true,
          // },
          // },
          // zoom: {
          //   enabled: true,
          //   type: 'x',
          // },
        },
        colors: [
          '#26e7a5', // Produzione
          '#269ffb', //Consumato
        ],
        xaxis: {
          categories: chartObj.labelDate,
          overwriteCategories: chartObj.overwriteLabelDate,
          labels: {
            show: true,
            rotate: 0,
          },
          // group: {
          //   groups: [
          //     {
          //       title: 'ABC',
          //       cols: 3,
          //     },
          //     {
          //       title: 'XYZ',
          //       cols: 4,
          //     },
          //   ],
          // },
        },
        yaxis: {
          labels: {
            formatter: (val) => {
              return (+val / 1000).toFixed(1) + 'kWh';
            },
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: 15,
          },
        },
        legend: {
          show: chartObj.legend,
          horizontalAlign: 'left',
          floating: false,
          showForSingleSeries: false,
          showForNullSeries: false,
          showForZeroSeries: false,
        },
        dataLabels: {
          enabled: false,
        },
        tooltip: {
          followCursor: false,
          intersect: true,
          items: {
            display: 'flex',
          },
          fixed: {
            enabled: true,
            position: 'center',
            offsetX: 550,
            offsetY: 0,
          },
        },
      };
    } else if (chartObj.startPeriod > 7) {
      // chartObj = this.createLabelDates(chartObj);
      this.chartOptions = {
        series: chartObj.series,
        chart: {
          type: 'bar',
          height: 400,
          width: 12000, // new
          offsetX: 0, // new
          stacked: false,
          toolbar: {
            show: true,
            offsetX: -400,
            tools: {
              download: true,
              selection: true,
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: true,
              reset: true,
            },
          },
          zoom: {
            enabled: true,
          },
        },
        colors: [
          '#26e7a5', // Produzione
          '#269ffb', //Consumato
        ],
        xaxis: {
          categories: chartObj.labelDate,
          overwriteCategories: chartObj.overwriteLabelDate,
          // type: 'category',
          // tickPlacement: 'on',
          // tickAmount: 7,
          labels: {
            show: true,
            rotate: 0,
            // offsetX: 130,
          },
          // group: {
          //   groups: [
          //     {
          //       title: 'ABC',
          //       cols: 3,
          //     },
          //     {
          //       title: 'XYZ',
          //       cols: 4,
          //     },
          //   ],
          // },
        },
        yaxis: {
          labels: {
            formatter: (val) => {
              return (+val / 1000).toFixed(1) + 'kWh';
            },
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: 15,
          },
        },
        stroke: {
          // width: 4,
          colors: ['transparent'],
        },
        legend: {
          show: chartObj.legend,
          horizontalAlign: 'left',
          floating: false,
          showForSingleSeries: false,
          showForNullSeries: false,
          showForZeroSeries: false,
        },
        dataLabels: {
          enabled: false,
        },
        tooltip: {
          followCursor: false,
          intersect: true,
          items: {
            display: 'flex',
          },
          fixed: {
            enabled: true,
            position: 'center',
            offsetX: 550,
            offsetY: 0,
          },
        },
      };
    } else {
      this.chartOptions = {
        series: chartObj.series,
        chart: {
          type: 'bar',
          height: 350,
        },
        colors: [
          '#26e7a5', // Produzione
          '#269ffb', //Consumato
        ],
        xaxis: {
          categories: chartObj.labelDate,
        },
        yaxis: {
          labels: {
            formatter: (val) => {
              return (+val / 1000).toFixed(1) + ' KWh';
            },
          },
        },
        plotOptions: {
          bar: {
            columnWidth: '80%',
            distributed: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        // tooltip: {
        //   y: {
        //     formatter: function (val) {
        //       return (+val / 1000).toFixed(1) + 'kWh';
        //     },
        //   },
        // },
        legend: {
          show: chartObj.legend,
          showForSingleSeries: false,
          showForNullSeries: false,
          showForZeroSeries: false,
        },
      };
    }

    return this.chartOptions;
  }

  createLabelDates(chartObj: consumiChartObj) {
    if (chartObj.type === 'months') {
      chartObj.labelDate = [];
      const daysInMonth = this.getTotalDaysInMonth(chartObj);
      for (let i = 1; i < daysInMonth + 1; i++) {
        const nextDate = new Date(chartObj.year, chartObj.month, i);
        nextDate.setDate(nextDate.getDate());
        chartObj.labelDate.push(nextDate.toLocaleDateString());
      }
      // } else if (chartObj.type === 'days' || chartObj.type === 'custom') {
      //   chartObj.overwriteLabelDate = [];
      //   for (let i = 0; i < chartObj.startPeriod + 1; i++) {
      //     const nextDate = new Date(chartObj.start);
      //     nextDate.setDate(nextDate.getDate() + i);
      //     chartObj.overwriteLabelDate.push(nextDate.toLocaleDateString());
      //   }
    }
    return chartObj;
  }

  formatDate(date: Date): string {
    // Formatta la data nel formato "DD"
    const day = ('0' + date.getDate()).slice(-2);
    return day;
  }

  getTotalDaysInMonth(chartObj: consumiChartObj): number {
    // month è 0-based, quindi sottrai 1
    const lastDayOfMonth = new Date(chartObj.year, chartObj.month + 1, 0);
    return lastDayOfMonth.getDate();
  }
}
